import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M10 8.64v6.72L15.27 12z",
  opacity: ".3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8 19l11-7L8 5v14zm2-10.36L15.27 12 10 15.36V8.64z"
})), 'PlayArrowTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/PlayArrowTwoTone.js
// module id = 5501
// module chunks = 2